import { Injectable } from '@angular/core';

import { CHANNEL } from '../../../../constants/channel.constants';
import { IChannelCommunicatorInterface } from '../../../../interfaces/channel-communicator.interface';
import { ExternalRequest } from '../../../../models/channel-communicator/external-request.model';
import { ExternalResponse } from '../../../../models/channel-communicator/external-response.model';
import { BaseChannelCommunicatorService } from '../base-channel-communicator.service';

@Injectable()
/**
 * Configuración inicial para la comunicación con portalpn
 *
 * *Initial config for comunication with portalpn*
 *
 * @type {class}
 * @extends {BaseChannelCommunicatorService}
 * @implements {IChannelCommunicatorInterface}
 */
export class PortalPnImplService extends BaseChannelCommunicatorService implements IChannelCommunicatorInterface {
  /**
   * Identificador del canal de portal pn
   *
   * *Portal pn channel id*
   */
  CHANNEL_ID = CHANNEL.PORTALPN.CODE;

  /**
   * Constructor de la clase
   *
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   *
   * *Initialize method for models*
   *
   * @function initService
   */
  constructor() {
    super();
    this.initService(true);
  }

  /**
   * Creación de la promesa para la comunicación con portalpn
   *
   * *Promise creation for portalpn communication*
   *
   * @param {string} op
   */
  createPromise(op: string): Promise<ExternalResponse> {

    return new Promise((resolve, _reject) => {
      const callback = (event: any) => {
        if (event.data.origin !== CHANNEL.PORTALPN.NAME || event.data.op !== op) { return; }
        resolve(event.data);
        window.removeEventListener('message', callback);
      };
      window.addEventListener('message', callback);
    });
  }

  /**
   * Llamada a una función Nativa dependiendo del canal
   *
   * *Calls native function depending on the channel*
   *
   * @param {ExternalRequest} request
   */
  postMessageToChannel(request: ExternalRequest) {
    window.parent.postMessage(request, '*');
  }
}
